<template lang="pug">
    div.pl-md-5.pr-md-5.pb-md-5.width-100-percent.brown.lighten-5(style="margin-top: 0px !important;")
        NewHeartBeat(
            v-if="validNewHeartBeat"
            :heart-beatable-id="newHeartBeat.heartBeatableId"
            :heart-beatable-type="newHeartBeat.heartBeatableType"
            :interval-ms="newHeartBeat.intervalMs"
            :source="newHeartBeat.source"
        )

        .text-center(v-if="isLoading")
            v-progress-circular(
                :size='100'
                :width='10'
                color='var(--volie-blue)'
                indeterminate
                style="margin-top: 100px;"
            )

        div(v-else)
            div.d-flex.justify-end.mb-2
                v-dialog(v-model='filterDialog' persistent max-width='500')
                    template(v-slot:activator='{ on, attrs }')
                        v-btn.btn-margin-xs(
                            color="primary"
                            icon
                            small
                            v-bind='attrs'
                            v-on='on'
                        )
                            v-icon mdi-filter

                    v-card
                        v-card-title.headline
                            | Filter
                        v-card-text
                            v-container
                                v-row
                                    v-col.mb-0.pb-0(cols='12')
                                        v-autocomplete(v-model='tmpFilterObj.teamIds' multiple :items='teams' label='Team' item-text="name" item-value="team_id" clearable)
                                            template(v-slot:selection='{ item, index }')
                                                v-chip
                                                    span {{ item.name }}
                                                //- v-chip(v-if='index === 0')
                                                //-     span {{ item.name }}
                                                //- span.grey--text.caption(v-if='index === 1')
                                                //-     | (+{{ tmpFilterObj.teamIds.length - 1 }} others)

                                v-row
                                    v-col.mb-0.pb-0(cols='12')
                                        v-checkbox(v-model='tmpFilterObj.makeDefaultFilter' :label='defaultFilterLabel')

                        v-card-actions
                            v-spacer
                            v-btn(color='var(--volie-blue)' outlined ripple text @click='closeFilter();')
                                v-icon mdi-close
                                | Close
                            v-btn(color='var(--volie-blue)' outlined ripple text @click='resetFilter();')
                                v-icon mdi-refresh
                                | Reset
                            v-btn(color='green' outlined ripple text @click='submitFilter();')
                                v-icon mdi-filter
                                | Filter

            AgentBoxes(
                :agents="agents"
                :filter-obj="filterObj"
            )

            v-divider.divider-spacing
            AgentIndex(
                :agents="agents"
                :filter-obj="filterObj"
                :teams="teams"
            )

</template>

<script lang="ts">
    import Vue from 'vue';

    // Components
    import AgentBoxes from '@/components/dashboards/live/agents/agent_boxes.vue';
    import AgentIndex from '@/components/dashboards/live/agents/agent_index.vue';
    import NewHeartBeat from '@/components/heart_beats/new.vue';

    // Helpers
    import { getCookie, setCookie } from '@/helpers/cookie';

    export default Vue.extend({
        data() {
            return {
                isLoading: false,
                filterDialog: false,
                tmpFilterObj: null,
                filterObj: null,
            }
        },
        methods: {
            closeFilter() {
                this.tmpFilterObj = { ...this.filterObj };
                this.filterDialog = false;
            },
            newFilterObj() {
                return {
                    teamIds: [],
                }
            },
            resetFilter() {
                this.filterObj = this.newFilterObj();
                this.tmpFilterObj = this.newFilterObj();

                if (this.setFilterObj !== undefined && this.setFilterObj !== null) {
                    this.setFilterObj(this.filterObj);
                }

                this.filterDialog = false;
            },
            initFilterObj() {
                const cookieValue = getCookie('v_dashboard_agents_filter');
                const newFilterObj = cookieValue ? JSON.parse(cookieValue) : this.newFilterObj();

                this.filterObj = { ...newFilterObj };
                this.tmpFilterObj = { ...newFilterObj };

                if (this.setFilterObj !== undefined && this.setFilterObj !== null) {
                    this.setFilterObj(this.filterObj);
                }
            },
            submitFilter() {
                this.filterObj = { ...this.tmpFilterObj };

                if (this.tmpFilterObj.makeDefaultFilter) {
                    // If no teams are selected, just pass empty teams (avoids the checkbox defaulting to true from cookie when it shouldn't)
                    const newCookieVal = (this.filterObj.teamIds?.length > 0) ? { ...this.filterObj } : { teamIds: [] };
                    setCookie('v_dashboard_agents_filter', JSON.stringify(newCookieVal));
                }

                if (this.setFilterObj !== undefined && this.setFilterObj !== null) {
                    this.setFilterObj(this.filterObj);
                }

                this.filterDialog = false;
            },
        },
        computed: {
            defaultFilterLabel() {
                return this.setFilterObj !== undefined && this.setFilterObj !== null ? 'Make this my default filter (applies to Overview and Agents tabs)' : 'Make this my default filter';
            },
            validNewHeartBeat() {
                return this.newHeartBeat?.heartBeatableId > 0 && this.newHeartBeat?.heartBeatableType?.length > 0;
            },
        },
        components: {
            AgentBoxes,
            AgentIndex,
            NewHeartBeat,
        },
        props: {
            agents: Array,
            newHeartBeat: Object,
            setFilterObj: Function,
            teams: Array,
        },
        watch: {
        },
        destroyed() {
        },
        created() {
            this.initFilterObj();
        },
    });
</script>

<style lang="scss" scoped>
</style>